import React, { useState, useEffect, useMemo } from "react";

// ** MUI Imports
import {
  IconButton,
  Button,
  Box,
  Typography,
  Card,
  CardContent,
  CardHeader,
  MenuItem,
  FormLabel,
  Grid,
  Divider,
  CircularProgress,
  Backdrop,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Collapse,
  Checkbox,
  FormControlLabel,
  Tooltip,
  InputAdornment,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { DataGridPro } from '@mui/x-data-grid-pro';

// ** Custom Component Imports
import CustomTextField from "components/mui/text-field";
import CustomAutocomplete from "components/mui/autocomplete";
import CustomChip from "components/mui/chip";
import CustomLabel from "components/CustomLabel";
import DatePopover from "./DatePickerSelection";
import AddIcon from "@mui/icons-material/Add";

// ** Icon Imports
import Icon from "components/icon";

// ** Dialog Imports
import PreviewInvoiceDialog from "./PreviewInvoice";
import SelectJobsDialog from "./SelectJobs";
import JobDetailDialog from "screens/WorkOrders/component/JobDetail";
import PreAttachment from "screens/Requests/component/PreAttachment";
import AddSalesTaxDialog from "screens/Settings/component/AddSalesTaxDialog";

// ** Third Party Components
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// ** Layout Import
import UserLayout from "components/layouts/UserLayout";

// ** Logic Imports
import { useCreateInvoice } from "../logic/invoice-logic";
import { GetIndividualPayment } from "../logic/GetPayment";
import { GetServiceRequests } from "screens/Requests/logic/GetServiceRequest";

const CreateInvoice = () => {
  const { JobSelectionProps, InvoiceCreationProps } = useCreateInvoice({toast, mode: 'creation'});

  const { handleOpenSelectJobsDlg, handleCloseSelectJobsDlg, invoiceType, selectedJobs } =
    JobSelectionProps;
    

  const {
    contentHeightFixed,
    theme,
    loading,
    openSelectJobsDlg,
    openAttachments,
    setOpenAttachments,
    handleRemoveAttachment,
    openNotes,
    setOpenNotes,
    openTNC,
    setOpenTNC,
    filteredRows,
    openJobDetail,
    jobID,
    openGenerateInvoice,
    handlePageBack,
    handleOpenGenerateInvoice,
    handleCloseGenerateInvoice,
    handleCloseJobDetail,
    columns,
    setInvoice,
    invoice,
    openUploadDlg, 
    uploadFiles, 
    setUploadFiles,
    handleOpenUploadDlg,
    handleCloseUploadDlg,
    attachments,
    setAttachments,
    selectedWorkReq,
    setSelectedWorkReq,
    selectedJob,
    setSelectedJob,
    fetchWorkRequirements,
    fetchJobs,
    fetchRecords,
    rules,
    note,
    setNote,
    handleAddNote,
    notes,
    handleDeleteNote,
    term,
    setTerm,
    handleAddTerm,
    terms,
    handleDeleteTerm,
    handleChangeTerm,
    handleChangeInvoiceDetails,
    handleSaveInvoice,
    navigate,
    setLoading,
    invoiceID,
    errorsDetails,
    salesTaxList,
    jobDetail,
    FileThumbnail,
    handleOpenCountyDlg,
    handleCloseCountyDlg,
    openCountyDlg,
    handleAddCounty,
    previewData
  } = InvoiceCreationProps;
   

  const parseAmount = (amount) => {
    return  parseFloat(amount || 0).toLocaleString('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }) 
  };
  

  // States
  const invID = invoice?.invoiceID;
  const reqID = invoice?.requestID;
  const [totalAmount, setTotalAmount] = useState(0);
  const [totalDiscount, setTotalDiscount] = useState(0);
  const [totalTax, setTotalTax] = useState(0);
  const [advanceReceived, setAdvanceReceived] = useState(0);
  const [balanceRemaining, setBalanceRemaining] = useState(0);
  const [grandTotal, setGrandTotal] = useState(0);
  const [advanceUtilized, setAdvanceUtilized] = useState(0);
  const [applyCredit, setApplyCredit] = useState(false);

  // Logic
  // useEffect(() => {
  //   let calculatedTotalAmount = 0;
  //   let calculatedTotalTax = 0;

  //   if (invoiceType === 'Assessment') {
  //     calculatedTotalAmount = parseFloat(invoice?.assessmentAmount || 0);
  //     if(invoice?.salesTax){
  //       calculatedTotalTax = calculatedTotalAmount * ((parseFloat(invoice?.salesTax || 0) / 100) || 0);
  //     }else {
  //       calculatedTotalTax = 0
  //     }
  //   } 
  //   else if (invoiceType === "WorkOrderDeposit"){
  //     calculatedTotalAmount = parseFloat(invoice?.depositAmount || 0);
  //     if(invoice?.salesTax){
  //       calculatedTotalTax = calculatedTotalAmount * ((parseFloat(invoice?.salesTax || 0) / 100) || 0);
  //     }else {
  //       calculatedTotalTax = 0
  //     }
  //   }
  //   else if (invoiceType === "WorkOrder") {
  //     const jobs = invoice?.invoiceJobs || [];
      
  //     calculatedTotalAmount = jobs.reduce((sum, job) => {
  //       return sum + parseFloat(job.totalAmount || 0);
  //     }, 0);

  //     calculatedTotalTax = jobs.reduce((sum, job) => {
  //       const jobTax = parseFloat(job.totalAmount || 0) * 
  //                     (parseFloat(invoice?.taxAmount || 0) / 100);
  //       return sum + jobTax;
  //     }, 0);
  //   }

  //   const calculatedDiscount = parseFloat(invoice?.discountAmount || 0);
  //   const subtotal = calculatedTotalAmount - calculatedDiscount;
  //   let calculatedGrandTotal = subtotal + calculatedTotalTax;

  //   let advanceUtilized = 0;

  //   if (applyCredit && advanceReceived && advanceReceived > 0) {
  //     if (advanceReceived >= calculatedGrandTotal) {
  //       advanceUtilized = calculatedGrandTotal;
  //       calculatedGrandTotal = 0;
  //     } else {
  //       advanceUtilized = advanceReceived;
  //       calculatedGrandTotal = calculatedGrandTotal - advanceReceived;
  //     }
  //   } else {
  //     advanceUtilized = 0;
  //   }
    
  //   setInvoice((prev) => ({
  //     ...prev,
  //     totalAmount: calculatedTotalAmount,
  //     subTotal: calculatedGrandTotal,
  //     depositUtilizedAmount: advanceUtilized,
  //     taxAmount: calculatedTotalTax
  //   }))

  //   // setTotalAmount(calculatedTotalAmount);
  //   // setTotalTax(calculatedTotalTax);
  //   // setTotalDiscount(calculatedDiscount);
  //   // setGrandTotal(calculatedGrandTotal);
  //   // setAdvanceUtilized(advanceUtilized);
  // }, [invoice])


// Replace your useMemo and useEffect with this:

const calculatedValues = useMemo(() => {
  let calculatedTotalAmount = 0;
  let calculatedTotalTax = 0;

  // Extract only the specific fields needed from invoice
  const assessmentAmount = parseFloat(invoice?.assessmentAmount || 0);
  const depositAmount = parseFloat(invoice?.depositRequired || 0);
  const salesTax = parseFloat(invoice?.salesTax || 0);
  const discountAmount = parseFloat(invoice?.discountAmount || 0);
  const invoiceJobs = invoice?.invoiceJobs || [];

  if (invoiceType === 'Assessment') {
    calculatedTotalAmount = assessmentAmount;
    calculatedTotalTax = salesTax ? calculatedTotalAmount * (salesTax / 100) : 0;
  } 
  else if (invoiceType === "WorkOrderDeposit") {
    calculatedTotalAmount = depositAmount;
    calculatedTotalTax = salesTax ? calculatedTotalAmount * (salesTax / 100) : 0;
  }
  else if (invoiceType === "WorkOrder") {
    calculatedTotalAmount = invoiceJobs.reduce((sum, job) => {
      return sum + parseFloat(job.totalAmount || 0);
    }, 0);
    calculatedTotalTax = salesTax ? calculatedTotalAmount * (salesTax / 100) : 0;
  }

  const calculatedDiscount = discountAmount;
  const subtotal = calculatedTotalAmount - calculatedDiscount;
  let calculatedGrandTotal = subtotal + calculatedTotalTax;

  let advanceUtilized = 0;

  if (applyCredit && advanceReceived && advanceReceived > 0) {
    if (advanceReceived >= calculatedGrandTotal) {
      advanceUtilized = calculatedGrandTotal;
      calculatedGrandTotal = 0;
    } else {
      advanceUtilized = advanceReceived;
      calculatedGrandTotal = calculatedGrandTotal - advanceReceived;
    }
  } else {
    advanceUtilized = 0;
  }

  return {
    totalAmount: calculatedTotalAmount,
    totalTax: calculatedTotalTax,
    totalDiscount: calculatedDiscount,
    grandTotal: calculatedGrandTotal,
    advanceUtilized: advanceUtilized
  };

}, [
  invoiceType, 
  applyCredit, 
  advanceReceived,
  invoice?.assessmentAmount,
  invoice?.depositAmount,
  invoice?.salesTax,
  invoice?.taxAmount,
  invoice?.discountAmount,
  invoice?.invoiceJobs
]);

useEffect(() => {
  if (!invoice) return;

  setInvoice(prev => {
    if (
      prev.totalAmount === calculatedValues.grandTotal &&
      prev.subTotal === calculatedValues.totalAmount &&
      prev.depositUtilizedAmount === calculatedValues.advanceUtilized &&
      prev.taxAmount === calculatedValues.totalTax
    ) {
      return prev;
    }

    return {
      ...prev,
      totalAmount: calculatedValues.grandTotal,
      subTotal: calculatedValues.totalAmount,
      depositUtilizedAmount: calculatedValues.advanceUtilized,
      taxAmount: calculatedValues.totalTax
    };
  });
}, [calculatedValues]);

  useEffect(() => {
    setInvoice(prev => ({
      ...prev,
      depositUtilizedAmount: applyCredit ? advanceUtilized : 0
    }));
  }, [advanceUtilized, applyCredit])
  
 useEffect(() => {
  const fetchPayment = async () => {
    try{
      const result = await GetServiceRequests(0, reqID,0, navigate);
      if(result && result.length > 0){
        const amountPaid = result[0].depositAmountPaid;
        const amountUtilized = result[0].depositUtilizedAmount;
        const difference = amountPaid - amountUtilized;

        setAdvanceReceived(difference);
        setBalanceRemaining(difference);
      }
    }catch(error){
      console.error("Error fetching payments:", error)
    }
  }
  if(invID || reqID){
    fetchPayment();
  }
}, [invID, reqID, grandTotal])

  // Handle apply credit checkbox change
  const handleApplyCreditChange = (event) => {
    setApplyCredit(event.target.checked);
  };

  // Check if credit is available
  const isCreditAvailable = advanceReceived > 0;

  // Styles
  const containerStyles = {
    display: 'flex', justifyContent: 'flex-end', alignItems: 'center'
  };

  const summaryStyles = {
    width: { md: '50%', sm: '100%'}
  };

  const summaryItemStyles = {
    display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 4
  }

  const grandTotalStyles = {
    display: 'flex',
    justifyContent: 'space-between', 
    alignItems: 'center', 
    mt: 4, 
    color: '#23A26D',
    fontWeight: 600,
    fontSize: '18px'
  }

  const isEmpty = !invoice || !invoice.requestID;
  const formatNumberWithCommas = (value) => {
  if (value === null || value === undefined) return '';

  const str = value.toString();

  // Allow partial numbers while typing (e.g. ".", "0.", ".5")
  if (str === '' || str === '.' || str === '0.' || /^\.\d*$/.test(str)) {
    return str;
  }

  // Remove commas and format integer part
  const parts = str.replace(/,/g, '').split('.');
  if (parts[0] !== '') {
    const num = Number(parts[0]);
    // Check if it's actually a valid number before formatting
    if (!isNaN(num)) {
      parts[0] = num.toLocaleString('en-US');
    }
  }

  return parts.join('.');
  };
  const removeCommas = (value) => value.replace(/,/g, '');

  return (
    <UserLayout
      contentHeightFixed={contentHeightFixed}
      activeLink={"Invoices"}
      showIcon={true}
      NavURL={handlePageBack}
    >
      <Card sx={{ width: "100%", height: "100%", position: "relative" }}>
        <CardHeader
          title={
            <>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: { xs: "column", sm: "row" }, // Stack on mobile, row on desktop
                  justifyContent: "space-between",
                  alignItems: { xs: "flex-start", sm: "center" }, // Left align on mobile
                  gap: 2, // Add spacing between stacked items
                  width: "100%",
                }}
              >
                <Box>
                  <Typography variant="h3" sx={{ fontWeight: "bold" }}>
                    New Invoice
                  </Typography>
                </Box>
                <Box sx={{ display: "flex", gap: 2 }}>
                  {!isEmpty && (
                    <>
                      <Button
                        variant="outlined"
                        color="main"
                        onClick={handleSaveInvoice}
                      >
                        Save as Draft
                      </Button>
                      <Button
                        variant="contained"
                        color="main"
                        onClick={handleOpenGenerateInvoice}
                      >
                        Preview & Send
                      </Button>
                    </>
                  )}
                </Box>
              </Box>
              <Divider
                sx={{
                  color: "text.disabled",
                  "& .MuiDivider-wrapper": { px: 6 },
                  fontSize: theme.typography.body2.fontSize,
                  my: (theme) => `${theme.spacing(6)} !important`,
                }}
              />
            </>
          }
        />
        <CardContent>
          <Grid container spacing={5}>
            <Grid item xs={12} sm={4} md={3}>
              <FormLabel
                sx={{ fontSize: "13px", color: "text.primary", mb: "4px" }}
              >
                Work Order/Assessment ID{" "}
                <span style={{ color: theme.palette.error.main }}>*</span>
              </FormLabel>
              <Box
                sx={{
                  border:
                    theme.palette.mode === "dark"
                      ? "1px solid rgba(208, 212, 241, 0.2)"
                      : `1px solid rgba(47, 43, 61, 0.2)`,
                  px: 2,
                  borderRadius: 1,
                  cursor: "default",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <Typography variant="body1" color="text.secondary">
                  {!isEmpty
                    ? `${invoice?.preFix}${String(
                        invoice?.requestID
                      ).padStart(3, "0")}`
                    : "Select"}
                </Typography>
                <Tooltip title="Select Work Order or Jobs">
                  <IconButton onClick={handleOpenSelectJobsDlg}>
                    <Icon icon="fluent-mdl2:search-and-apps" />
                  </IconButton>
                </Tooltip>
              </Box>
            </Grid>

            {!isEmpty && (
              <>
                <Grid item xs={12}>
                  <Box
                    sx={{
                      border: `1px solid #DDDDDD`,
                      borderRadius: 1,
                    }}
                  >
                    <Box
                      sx={{
                        mx: 4,
                        my: 4,
                      }}
                    >
                      <Typography variant="h4">Invoice Details</Typography>
                    </Box>
                    <Divider sx={{ color: "text.disabled" }} />
                    <Grid
                      container
                      spacing={4}
                      sx={{
                        px: 4,
                        py: 6,
                      }}
                    >
                      <Grid item xs={12}>
                        <Box
                          sx={{
                            display: "flex",
                            flexDirection: { xs: "column", sm: "row" },
                            justifyContent: "space-between",
                            border: "1px solid #DDDDDD",
                            borderRadius: 1,
                            p: 4,
                            gap: 3,
                          }}
                        >
                          <Box
                            sx={{
                              display: "flex",
                              flexDirection: "column",
                              gap: 1,
                            }}
                          >
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "baseline",
                                gap: 2,
                              }}
                            >
                              <Typography variant="body1" fontWeight="bold">
                                Customer:
                              </Typography>{" "}
                              <Typography
                                variant="body2"
                                color="text.secondary"
                              >
                                {invoice?.customerName || "N/A"}
                              </Typography>
                            </Box>
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "baseline",
                                gap: 2,
                              }}
                            >
                              <Typography variant="body1" fontWeight="bold">
                                Billing Address:
                              </Typography>
                              <Typography
                                variant="body2"
                                color="text.secondary"
                              >
                                {invoice?.billingAddress_Street1?.trim() ||
                                  invoice?.jobsiteAddress?.trim() ||
                                  "N/A"}
                              </Typography>
                            </Box>
                            <Box
                              sx={{
                                display: "flex",
                                flexDirection: { xs: "column", sm: "row" }, // Stack vertically on mobile, row on desktop
                                gap: { xs: 1, sm: 2 }, // Smaller gap on mobile
                                alignItems: {
                                  xs: "flex-start",
                                  sm: "baseline",
                                }, // Left align on mobile
                                flexWrap: "wrap",
                              }}
                            >
                              {/* Phone */}
                              <Box sx={{ display: "flex", gap: 2 }}>
                                <Typography variant="body1" fontWeight="bold">
                                  Phone:
                                </Typography>
                                <Typography
                                  variant="body2"
                                  color="text.secondary"
                                >
                                  {invoice?.customerPhone || "N/A"}
                                </Typography>
                              </Box>

                              <Box
                                sx={{
                                  display: "flex",
                                  gap: 2,
                                  width: { xs: "100%", sm: "auto" },
                                }}
                              >
                                <Typography variant="body1" fontWeight="bold">
                                  Email:
                                </Typography>
                                <Typography
                                  variant="body2"
                                  color="text.secondary"
                                  sx={{
                                    wordBreak: "break-word",
                                    overflowWrap: "break-word",
                                  }}
                                >
                                  {invoice?.customerEmail || "N/A"}
                                </Typography>
                              </Box>
                            </Box>
                          </Box>
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "baseline",
                              gap: 2,
                            }}
                          >
                            <Typography variant="body1" fontWeight="bold">
                              Jobsite:
                            </Typography>
                            <Typography variant="body2" color="text.secondary">
                              {`${invoice?.jobsiteName} - ${invoice?.jobsiteAddress}`}
                            </Typography>
                          </Box>
                        </Box>
                      </Grid>
                      <Grid item xs={12} sm={4} md={3}>
                        <CustomTextField
                          fullWidth
                          label="Invoice Title"
                          placeholder="Enter Invoice Title"
                          value={invoice?.invoiceTitle || ""}
                          onChange={(e) => {
                            handleChangeInvoiceDetails(
                              "invoiceTitle",
                              e.target.value
                            );
                          }}
                        />
                      </Grid>
                      <Grid item xs={12} sm={4} md={3}>
                        <Box
                          sx={{
                            width: "100%",
                          }}
                        >
                          <CustomLabel label="Due Date" required={true} />
                          <DatePopover
                            onChange={handleChangeInvoiceDetails}
                            invoiceDetails={invoice}
                          />
                        </Box>
                      </Grid>
                      <Grid item xs={12} sm={4} md={3}>
                        <CustomTextField
                          fullWidth
                          select
                          SelectProps={{
                            multiple: true,
                            value: invoice?.paymentMethods || [],
                            onChange: (e) => {
                              if (e.target.value.includes("select-all")) {
                                const allMethods = [
                                  "Cash",
                                  "Cheque",
                                  "Credit Card",
                                  "Bank Transfer",
                                ];
                                handleChangeInvoiceDetails(
                                  "paymentMethods",
                                  invoice?.paymentMethods?.length ===
                                    allMethods.length
                                    ? []
                                    : allMethods
                                );
                              } else {
                                handleChangeInvoiceDetails(
                                  "paymentMethods",
                                  e.target.value
                                );
                              }
                            },
                            renderValue: (selected) => {
                              if (selected.length === 0)
                                return "Select Payment Methods";

                              return selected
                                .map((method) =>
                                  method === "Cheque" ? "Check" : method
                                )
                                .join(", ");
                            },
                            displayEmpty: true,
                            MenuProps: {
                              sx: {
                                "& .MuiMenuItem-root": {
                                  backgroundColor: "transparent",
                                  "&.Mui-selected": {
                                    backgroundColor: "transparent",
                                    "&:hover": {
                                      backgroundColor: "action.hover",
                                    },
                                  },
                                },
                              },
                            },
                          }}
                          required
                          label="Accepted Payment Methods"
                          error={!!errorsDetails.paymentMethods}
                          helperText={
                            !!errorsDetails.paymentMethods
                              ? "Select at least 1 payment method"
                              : ""
                          }
                        >
                          <MenuItem value="select-all">Select All</MenuItem>
                          {[
                            "Cash",
                            "Cheque",
                            "Credit Card",
                            "Bank Transfer",
                          ].map((method) => (
                            <MenuItem key={method} value={method}>
                              {method === "Cheque" ? "Check" : method}
                            </MenuItem>
                          ))}
                        </CustomTextField>
                      </Grid>
                      {invoiceType === "Assessment" && (
                        <Grid item xs={12} sm={4} md={3}>
                          <CustomTextField
                            fullWidth
                            required
                            label="Assessment Amount"
                            placeholder="0.00"
                            type="text"
                            value={formatNumberWithCommas(
                              invoice?.assessmentAmount || 0
                            )}
                            onChange={(e) => {
                              handleChangeInvoiceDetails(
                                "assessmentAmount",
                                removeCommas(e.target.value)
                              );
                            }}
                            InputProps={{
                              startAdornment: (
                                <InputAdornment position="start">
                                  $
                                </InputAdornment>
                              ),
                            }}
                            error={!!errorsDetails.assessmentAmount}
                            helperText={
                              !!errorsDetails.assessmentAmount
                                ? "Amount must be greater than 0"
                                : ""
                            }
                          />
                        </Grid>
                      )}
                      {invoiceType === "WorkOrderDeposit" && (
                        <Grid item xs={12} sm={4} md={3}>
                          <CustomTextField
                            fullWidth
                            required
                            readOnly
                            label="Deposit Amount"
                            placeholder="0.00"
                            value={formatNumberWithCommas(
                              invoice?.depositRequired || 0
                            )}
                            InputProps={{
                              startAdornment: (
                                <InputAdornment position="start">
                                  $
                                </InputAdornment>
                              ),
                            }}
                          />
                        </Grid>
                      )}
                    </Grid>
                  </Box>
                </Grid>
              </>
            )}
            {!isEmpty && invoiceType === "WorkOrder" && (
              <>
                <Grid item xs={12}>
                  <Typography variant="h4" mb={2}>
                    Invoice Items
                  </Typography>
                  <DataGridPro
                    autoHeight
                    hideFooter
                    rows={filteredRows || []}
                    columns={columns}
                    disableRowSelectionOnClick
                    sx={{
                      "& .MuiDataGrid-columnHeaderTitle": {
                        textTransform: "none",
                      },
                    }}
                  />
                </Grid>
              </>
            )}
            {!isEmpty && (
              <>
                <Grid item xs={12} sm={4} md={3}>
                 <CustomAutocomplete
                    fullWidth
                    options={
                      salesTaxList
                        ? [
                            { salesTaxID: "add_new_county", county: "Add New County", rate: null },
                            ...[...salesTaxList].sort((a, b) =>
                              a.county.localeCompare(b.county, undefined, { sensitivity: "base" })
                            ),
                          ]
                        : []
                    }
                    getOptionLabel={(option) => {
                      if (option.salesTaxID === "add_new_county") return "Add New County";
                      return `${option.county} (Sales Tax: ${option.rate}%)`;
                    }}
                    value={
                      salesTaxList.find((tax) => tax.rate === invoice?.salesTax) || null
                    }
                    onChange={(event, newValue) => {
                      if (!newValue) return;
                      if (newValue.salesTaxID === "add_new_county") {
                        handleOpenCountyDlg();
                        return;
                      }

                      handleChangeInvoiceDetails("salesTax", newValue.rate);
                      handleChangeInvoiceDetails("county", newValue.county);
                    }}
                    isOptionEqualToValue={(option, value) =>
                      option?.salesTaxID === value?.salesTaxID
                    }
                    renderOption={(props, option) => {
                      if (option.salesTaxID === "add_new_county") {
                        return (
                          <MenuItem
                            {...props}
                            key="add_new_county"
                            onClick={(e) => {
                              e.stopPropagation();
                              handleOpenCountyDlg();
                            }}
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              gap: 1,
                              borderBottom: "1px solid rgba(0,0,0,0.1)",
                            }}
                          >
                            <AddIcon fontSize="small" />
                            <Typography>Add New County</Typography>
                          </MenuItem>
                        );
                      }
                      return (
                        <MenuItem {...props} key={option.salesTaxID}>
                          {`${option.county} (Sales Tax: ${option.rate}%)`}
                        </MenuItem>
                      );
                    }}
                    renderInput={(params) => (
                      <CustomTextField
                        {...params}
                        label={
                          <Typography variant="body1" fontWeight="bold">
                            Sales Tax
                          </Typography>
                        }
                        placeholder="Search or select county"
                      />
                    )}
                    noOptionsText="No matching county"
                    sx={{ width: "100%" }}
                  />
                </Grid>
                <Grid item xs={12}>
                  <Box sx={containerStyles}>
                    <Box sx={summaryStyles}>
                      <Box sx={summaryItemStyles}>
                        <Typography variant="body1" fontWeight="bold">
                          Total Amount
                        </Typography>
                        <Typography variant="body1">
                          $ {parseAmount(invoice.subTotal || 0)}
                        </Typography>
                      </Box>
                      {(invoiceType === "WorkOrder" ||
                        invoiceType === "Assessment") && (
                        <>
                          
                          {isCreditAvailable && (
                            <Box sx={summaryItemStyles}>
                              <Typography variant="body1" fontWeight="bold">
                                Deposit Credit Available
                              </Typography>
                              <Typography
                                variant="body1"
                                sx={{ whiteSpace: "nowrap" }}
                              >
                                $ {parseAmount(advanceReceived || 0)}
                              </Typography>
                            </Box>
                          )}

                          
                          {isCreditAvailable && (
                            <Box sx={{ ...summaryItemStyles, ml: -5 }}>
                              {" "}
                              {/* Add negative margin left */}
                              <Box
                                sx={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: 0,
                                }}
                              >
                                <Checkbox
                                  checked={applyCredit}
                                  onChange={handleApplyCreditChange}
                                  color="success"
                                  size="small"
                                />
                                <Typography variant="body1" fontWeight="bold">
                                  Apply Deposit Credits
                                </Typography>
                              </Box>
                              <Typography variant="body1">
                                {applyCredit
                                  ? `$ ${parseAmount(
                                      invoice?.depositUtilizedAmount || 0
                                    )}`
                                  : "$ 0.00"}
                              </Typography>
                            </Box>
                          )}

                          <Box sx={summaryItemStyles}>
                            <Typography variant="body1" fontWeight="bold">
                              Total Discount
                            </Typography>
                            <Box
                              sx={{
                                maxWidth: 100,
                                ml: 5,
                              }}
                            >
                              <CustomTextField
                                fullWidth
                                placeholder="0.00"
                                value={invoice?.discountAmount || 0}
                                onChange={(e) => {
                                  handleChangeInvoiceDetails(
                                    "discountAmount",
                                    e.target.value
                                  );
                                }}
                                InputProps={{
                                  startAdornment: (
                                    <InputAdornment position="start">
                                      $
                                    </InputAdornment>
                                  ),
                                }}
                                error={!!errorsDetails.discountAmount}
                                helperText={
                                  !!errorsDetails.discountAmount
                                    ? "Discount must not exceed total amount"
                                    : ""
                                }
                              />
                            </Box>
                          </Box>
                        </>
                      )}
                      <Box sx={summaryItemStyles}>
                        <Typography variant="body1" fontWeight="bold">
                          Total Tax
                        </Typography>
                        <Typography variant="body1">
                          $ {parseAmount(invoice.taxAmount || 0)}
                        </Typography>
                      </Box>
                      <Divider />
                      <Box sx={grandTotalStyles}>
                        <Typography
                          variant="body1"
                          fontWeight="inherit"
                          color="inherit"
                          fontSize="inherit"
                        >
                          Grand Total
                        </Typography>
                        <Typography
                          variant="body1"
                          fontWeight="inherit"
                          color="inherit"
                          fontSize="inherit"
                        >
                          $ {parseAmount(invoice.totalAmount || 0)}
                        </Typography>
                      </Box>
                    </Box>
                  </Box>
                </Grid>
                <Grid item xs={12}>
                  <Typography variant="h4" mb={2}>
                    Additional Options
                  </Typography>
                  <List component="nav" aria-label="main mailbox">
                    <ListItem
                      disablePadding
                      sx={{ borderBottom: "1px solid #E1E4EA" }}
                    >
                      <ListItemButton
                        onClick={() => setOpenAttachments(!openAttachments)}
                      >
                        <Icon
                          icon={
                            openAttachments
                              ? "tabler:chevron-down"
                              : "tabler:chevron-right"
                          }
                        />
                        <ListItemText
                          sx={{ ml: 4 }}
                          primary={
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                              }}
                            >
                              <Typography variant="body1" fontWeight="bold">
                                Attachments
                              </Typography>
                              <CustomChip
                                label={attachments.length}
                                skin="light"
                                color="success"
                              />
                            </Box>
                          }
                        />
                      </ListItemButton>
                    </ListItem>
                    <Collapse in={openAttachments} timeout="auto" unmountOnExit>
                      <Grid container spacing={5}>
                        <Grid item xs={12}>
                          <Box
                            sx={{
                              display: "flex",
                              mt: 2,
                              gap: 5,
                            }}
                          >
                            {attachments && attachments.length > 0 ? (
                              attachments.map((attachment, index) => (
                                <ListItem
                                  key={index}
                                  sx={{
                                    display: "flex",
                                    gap: 2,
                                    width: "max-content",
                                    boxShadow:
                                      "rgba(0, 0, 0, 0.24) 0px 3px 8px",
                                    borderRadius: "10px",
                                  }}
                                >
                                  <Tooltip
                                    title={
                                      <>
                                        <Typography
                                          variant="body1"
                                          color="white"
                                        >
                                          {attachment.name}
                                        </Typography>
                                      </>
                                    }
                                  >
                                    <Box>
                                      <FileThumbnail file={attachment} />
                                    </Box>
                                  </Tooltip>
                                  <Box
                                    sx={{
                                      display: "flex",
                                      flexDirection: "column",
                                    }}
                                  >
                                    <Tooltip title="Remove">
                                      <IconButton
                                        onClick={() =>
                                          handleRemoveAttachment(
                                            attachment.name
                                          )
                                        }
                                      >
                                        <Icon icon="tabler:x" fontSize={20} />
                                      </IconButton>
                                    </Tooltip>
                                  </Box>
                                </ListItem>
                              ))
                            ) : (
                              <></>
                            )}
                            <Button
                              variant="outlined"
                              color="secondary"
                              onClick={handleOpenUploadDlg}
                            >
                              <Icon icon="tabler:plus" />
                            </Button>
                          </Box>
                        </Grid>
                      </Grid>
                    </Collapse>
                  </List>
                  <List component="nav" aria-label="main mailbox">
                    <ListItem
                      disablePadding
                      sx={{ borderBottom: "1px solid #E1E4EA" }}
                    >
                      <ListItemButton onClick={() => setOpenNotes(!openNotes)}>
                        <Icon
                          icon={
                            openNotes
                              ? "tabler:chevron-down"
                              : "tabler:chevron-right"
                          }
                        />
                        <ListItemText
                          sx={{ ml: 4 }}
                          primary={
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                              }}
                            >
                              <Typography variant="body1" fontWeight="bold">
                                Notes
                              </Typography>
                              <CustomChip
                                label={notes.length}
                                skin="light"
                                color="success"
                              />
                            </Box>
                          }
                        />
                      </ListItemButton>
                    </ListItem>
                    <Collapse in={openNotes} timeout="auto" unmountOnExit>
                      <Grid container spacing={3} mt={2}>
                        {notes &&
                          notes.length > 0 &&
                          notes.map((note, index) => (
                            <Grid key={index} item xs={12}>
                              <Box
                                sx={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                  border: "1px solid #D0D5DD",
                                  borderRadius: 1,
                                  gap: 2,
                                  px: 2,
                                  backgroundColor:
                                    theme.palette.mode === "dark"
                                      ? "##1B2431 !important"
                                      : "#fff !important",
                                }}
                              >
                                <Box>
                                  <Typography variant="body2">
                                    {index + 1}
                                    {`. `}
                                    {note.description}
                                  </Typography>
                                </Box>
                                <Box
                                  sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 2,
                                  }}
                                >
                                  <IconButton
                                    onClick={() =>
                                      handleDeleteNote(note.id, "create")
                                    }
                                  >
                                    <Icon icon="tabler:x" />
                                  </IconButton>
                                </Box>
                              </Box>
                            </Grid>
                          ))}
                        <Grid item xs={12}>
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              gap: 2,
                            }}
                          >
                            <CustomTextField
                              fullWidth
                              placeholder="Type any note"
                              sx={{
                                backgroundColor:
                                  theme.palette.mode === "dark"
                                    ? "##1B2431 !important"
                                    : "#fff !important",
                              }}
                              value={note}
                              onChange={(e) => setNote(e.target.value)}
                            />
                            <Button
                              variant="outlined"
                              color="secondary"
                              onClick={() => handleAddNote("create")}
                            >
                              <Icon icon="tabler:plus" />
                            </Button>
                          </Box>
                        </Grid>
                      </Grid>
                    </Collapse>
                  </List>
                  <List component="nav" aria-label="main mailbox">
                    <ListItem
                      disablePadding
                      sx={{ borderBottom: "1px solid #E1E4EA" }}
                    >
                      <ListItemButton onClick={() => setOpenTNC(!openTNC)}>
                        <Icon
                          icon={
                            openTNC
                              ? "tabler:chevron-down"
                              : "tabler:chevron-right"
                          }
                        />
                        <ListItemText
                          sx={{ ml: 4 }}
                          primary={
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                              }}
                            >
                              <Typography variant="body1" fontWeight="bold">
                                Terms & Conditions
                              </Typography>
                              <CustomChip
                                label={terms.length}
                                skin="light"
                                color="success"
                              />
                            </Box>
                          }
                        />
                      </ListItemButton>
                    </ListItem>
                    <Collapse in={openTNC} timeout="auto" unmountOnExit>
                      <Grid container spacing={3} mt={2}>
                        {terms &&
                          terms.length > 0 &&
                          terms.map((term, index) => (
                            <Grid key={index} item xs={12}>
                              <Box
                                sx={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                  border: "1px solid #D0D5DD",
                                  borderRadius: 1,
                                  gap: 2,
                                  px: 2,
                                  backgroundColor:
                                    theme.palette.mode === "dark"
                                      ? "##1B2431 !important"
                                      : "#fff !important",
                                }}
                              >
                                <Box>
                                  <Typography variant="body2">
                                    {index + 1}
                                    {`. `}
                                    {term.paymentTerms}
                                  </Typography>
                                </Box>
                                <Box
                                  sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 2,
                                  }}
                                >
                                  <FormControlLabel
                                    control={
                                      <Checkbox
                                        checked={term.isActive}
                                        color="success"
                                        onChange={(e) =>
                                          handleChangeTerm(
                                            e.target.checked,
                                            term.id,
                                            "create"
                                          )
                                        }
                                      />
                                    }
                                    label="Apply"
                                  />
                                  <IconButton
                                    onClick={() => handleDeleteTerm(term.id)}
                                  >
                                    <Icon icon="tabler:x" />
                                  </IconButton>
                                </Box>
                              </Box>
                            </Grid>
                          ))}
                        <Grid item xs={12}>
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              gap: 2,
                            }}
                          >
                            <CustomTextField
                              fullWidth
                              placeholder="Type your terms & conditions"
                              sx={{
                                backgroundColor:
                                  theme.palette.mode === "dark"
                                    ? "##1B2431 !important"
                                    : "#fff !important",
                              }}
                              value={term}
                              onChange={(e) => setTerm(e.target.value)}
                            />
                            <Button
                              variant="outlined"
                              color="secondary"
                              onClick={() => handleAddTerm("create")}
                            >
                              <Icon icon="tabler:plus" />
                            </Button>
                          </Box>
                        </Grid>
                      </Grid>
                    </Collapse>
                  </List>
                </Grid>
              </>
            )}
          </Grid>
        </CardContent>
      </Card>

      {/* Popup Dialogs */}
      <PreviewInvoiceDialog
        open={openGenerateInvoice}
        handleClose={handleCloseGenerateInvoice}
        toast={toast}
        navigate={navigate}
        setLoading={setLoading}
        invoiceID={invoiceID}
        previewData={previewData}
        terms={terms}
        notes={notes}
        invoiceType={invoiceType}
        invoiceJobs={selectedJobs}
      />

      <SelectJobsDialog
        open={openSelectJobsDlg}
        handleClose={handleCloseSelectJobsDlg}
        JobSelectionProps={JobSelectionProps}
      />

      <JobDetailDialog
        open={openJobDetail}
        handleClose={handleCloseJobDetail}
        method={"detail"}
        entity={"workOrder-detail"}
        rules={rules}
        workReq={selectedWorkReq}
        job={selectedJob}
        setJob={setSelectedJob}
        fetchWorkRequirements={fetchWorkRequirements}
        setLoading={setLoading}
        toast={toast}
        fetchRequests={fetchRecords}
      />

      <PreAttachment
        Title="Upload Attachment"
        open={openUploadDlg}
        handleClose={handleCloseUploadDlg}
        files={uploadFiles}
        setFiles={setUploadFiles}
        f={attachments}
        sf={setAttachments}
      />

      <AddSalesTaxDialog
        open={openCountyDlg}
        handleClose={handleCloseCountyDlg}
        onSave={handleAddCounty}
      />

      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 10000 }}
        open={loading}
      >
        <CircularProgress color="inherit" />
    </Backdrop>      
    </UserLayout>
  );
};

export default CreateInvoice;